import React, { Component, useState } from "react";
import { Background } from "react-parallax";
import { Helmet } from "react-helmet-async";

export function Helmetx() {

    return (
        <Helmet>
            <title>{Branding().Title} | Starta din egen obemannade 24/7-butik</title>
            <meta
            name="description"
            content="Starta en egen obemannad butik med Närbutik.se. Låt kunder identifiera sig med BankID, låsa upp, skanna varor och betala direkt i mobilen."
            />
        </Helmet>
    );
}     

export function DateTimeToLocal(isoDate)  {
    var d = new Date(isoDate);
    return d.toLocaleDateString() + " " + d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
}

export function MultiselectGetOptions(rawData) {
    var options = new Array();
    rawData.forEach(element => {
        options.push({ value: element.id, label: element.name });
    });
    return options;
}

export function MultiselectGetDefaultValues(rawData, selectedValues){
    var SelectedValues = [];
    rawData.forEach(Data => {
        if (selectedValues.includes(Data.id)) SelectedValues.push({ value: Data.id, label: Data.name });
    });
    return SelectedValues;
}

export function escapedNewLineToLineBreakTag(string){
    return string.split("\\n").join("\n");
}

export function ConcatLocalDateAndTime2ISO(LocalDateString, LocalTimeString){
    try {
        var LocalDateString = LocalDateString+"T"+LocalTimeString;
        var d = new Date(LocalDateString)
        return d.toISOString();
    } catch {
        var d = new Date();
        return d.toISOString();
    }
} 

export function SplitoutLocalDateFromISO(isoDate){
    var d = new Date(isoDate);
    return d.toLocaleDateString();
}  

export function SplitoutLocalTimeFromISO(isoDate){
    if (isoDate.length <= 8 ) isoDate = '1900-01-01T'+isoDate+"Z";
    var d = new Date(isoDate);
    return d.toLocaleTimeString([],  {hour: '2-digit', minute:'2-digit'});
}


// FFAF00 Nookshop
// F88B00 Närbutik
export function Branding(){
            if (window.location.origin=="https://www.nookshop.se")
                return {Background : "#F07500", ButtonColor : "#F07500", Title : "Nookshop", Headline : "nookshop.se", Mail:"info@cloudsolution.se"};
            else
                return {Background : "#F07500", ButtonColor : "#F07500", Title : "Närbutik.se", Headline : "närbutik.se", Mail:"info@narbutik.se"};
}



export function getOptions(object){
    return object.map((state) => {
        return <option key={state.Id} value={state.Id}>{state.Name}</option>;
    });
}    